import { createAction, props } from '@ngrx/store';
import { IBusinessPaymentRunDetailEmployees } from '../dto/business-payment-run-detail-employees.dto';
import { IFilterPaymentRunsRequest } from '../models/filter.model';

export const loadFilterBusinessPaymentRunsDetailEmployees = createAction(
  '[FilterBusinessPaymentRunsDetailEmployees] Load FilterBusinessPaymentRunsDetailEmployees',
  props<{
    businessId: string;
    businessPaymentRunId: string;
    request: IFilterPaymentRunsRequest;
  }>()
);

export const loadFilterBusinessPaymentRunsDetailEmployeesSuccess = createAction(
  '[FilterBusinessPaymentRunsDetailEmployees] Load FilterBusinessPaymentRunsDetailEmployees Success',
  props<{ response: IBusinessPaymentRunDetailEmployees[] }>()
);

export const loadFilterBusinessPaymentRunsDetailEmployeesFailure = createAction(
  '[FilterBusinessPaymentRunsDetailEmployees] Load FilterBusinessPaymentRunsDetailEmployees Failure',
  props<{ error: Error | any }>()
);
